export default "__VITE_ASSET__BpqDVtbs__"